module.exports = __webpack_public_path__ + "static/media/hack_12_bg.a3f983a4.jpg";